import React, { useEffect, useState } from "react";
import "./Authors.css";
import { Helmet } from "react-helmet";

const Authors = () => {
  const [authors, setAuthors] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const authorsPerPage = 16;

  const fetchAuthors = async (page) => {
    try {
      const response = await fetch(
        `https://issani.co.in/api/api.php?api=getAuthors&page=${page}&limit=${authorsPerPage}`
      );
      const data = await response.json();
      setAuthors(data.authors);
      setTotalPages(data.pagination.total_pages);
      setCurrentPage(data.pagination.current_page);
    } catch (error) {
      console.error("Error fetching authors:", error);
    }
  };

  useEffect(() => {
    fetchAuthors(currentPage);
  }, [currentPage]);

  return (
    <div className="authors-container">
      <Helmet>
        <title>ನಮ್ಮ ಬರಹಗಾರರು - Issani</title>
        <meta
          name="description"
          content="Welcome to Issani, explore posts and authors."
        />
      </Helmet>
      <h1>ನಮ್ಮ ಬರಹಗಾರರು</h1>
      <div className="authors-grid">
        {authors.map((author) => (
          <div key={author.uid} className="author-card">
            <img
              src={
                author.pic
                  ? `/assets/${author.pic}` // Local folder for profile pictures
                  : "/assets/default-author.png" // Local default image
              }
              alt={author.name}
              className="author-image"
            />
            <h2>{author.name}</h2>
            <a href={`/author/${author.uid}`} className="view-posts-link">
              ಇವರ ಬರಹಗಳು
            </a>
          </div>
        ))}
      </div>
      <div className="pagination">
        <button
          onClick={() => setCurrentPage(currentPage - 1)}
          disabled={currentPage === 1}
        >
          Previous
        </button>
        <span>
          Page {currentPage} of {totalPages}
        </span>
        <button
          onClick={() => setCurrentPage(currentPage + 1)}
          disabled={currentPage === totalPages}
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default Authors;
